<template>
<div id="board" ref="board" style="height:calc( 100vh - 128px );overflow-y:scroll;">
      <!--<stack :column-min-width="320" :gutter-width="8" :gutter-height="8">
        <stack-item v-for="(item, i) in notes" :key="i">
          <v-card height="500px">
            {{ item.text }}
          </v-card>
        </stack-item>
      </stack>-->

  <v-row id="board-inner" ref="boardInner" class="ma-0 text-center" style="width:100%;min-height:calc( 100vh - 128px );">

      <Waterfall
        style="width:100%;"
        :line-gap="400"
        :min-line-gap="300"
        :max-line-gap="520"
        :watch="notes"
        ref="waterfall"
      >
        <!-- each component is wrapped by a waterfall slot -->
        <WaterfallSlot
          v-for="(item, index) in notes"
          :width="item.width"
          :height="item.height"
          :order="index"
          :key="index"
          move-class="item-move"
        >
        <v-row align="center"
          style="height:100%;"
          justify="center">
          <v-col>
              <v-card flat
                :class="['my-8', `${item.style.fontColor}--text lighten-1`]"
                width="400px"
                :style="{
                  'font-family': item.style.fontFamily,
                  'font-color': 'rgb(255,0,0) !important',
                  'background-color': 'rgb(255,255,255,0)',
                  'box-shadow': 'none !important',
                  rotate: item.style.rotation,}">

                <v-card-actions class="pb-1"
                  :style="{
                    'font-size': `${item.style.fontSize}`,}">
                {{ item.text }}
                </v-card-actions>

                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-col class="pt-0"
                      :style="{
                        'font-size': `${item.style.fontSize}`,}">
                      {{ item.author }}
                      {{ formatDate(item.updatedAt) }}
                    </v-col>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </WaterfallSlot>
      </Waterfall>
  </v-row>

    <v-dialog
      v-model="dialog"
      :persistent="!writeSomething"
      max-width="600"
    >
      <v-card v-if="writeSomething">
        <v-card-title class="headline">
          Schreib deine Gedanken zu "{{ eventTitle}}"
        </v-card-title>

        <v-card-text class="mt-5">
          Lass alle wissen was in deinem Kopf vor geht.
        </v-card-text>

        <v-card-text>
          <v-textarea
            outlined
            label="Deine Gedanken"
            v-model="yourThoughts"
            counter
            autofocus
          ></v-textarea>
        </v-card-text>

        <v-card-text>
          <v-text-field
                v-model="pseudonym"
                label="Pseudonym"
                placeholder="Anonymous"
                outlined
              ></v-text-field>
        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            @click="dialog = false"
            elevation="2"
            text
            outlined
            class="ma-2"
          >
            Cancel
          </v-btn>

          <v-btn
            color="green darken-1"
            @click="publishCommentary"
            elevation="2"
            text
            outlined
            class="ma-2"
          >
            Publish
          </v-btn>
        </v-card-actions>
      </v-card>

      <v-card v-else-if="dialog">
        <v-card-title class="headline">
          Applaus für "{{ eventTitle}}"
        </v-card-title>

        <v-card-text class="mt-5">
          Schick uns deinen Applaus und lass auch Andere daran teilhaben.
        </v-card-text>

        <v-card-text>
          Du darfst auch allen deine Meinung unter deinem ganz eigenen Pseudonym kundtun.
        </v-card-text>

        <v-card-text>
          Es wird Sound zu hören sein. Level also deine Audioausgabe.
        </v-card-text>

        <v-card-actions>

          <v-spacer></v-spacer>

          <v-btn
            color="green darken-1"
            @click="agreed"
            elevation="2"
            text
            outlined
            class="ma-2"
          >
            OK
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-toolbar
      color="primary"
      bottom
      dark
      absolute
      style="width:100%;"
    >
      <v-row style="margin-bottom:6em;">
        <v-col cols="3" class="d-flex justify-space-around">
          <v-btn height="80px"
            width="80px"
            fab
            elevation="2"
            class="blue darken-2 mx-auto"
            :disabled="rocketDisabled"
            @click="newFireWorkOnClick">
              <v-icon size="60px">mdi-firework</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="3" class="d-flex justify-space-around">
          <v-btn height="80px"
            width="80px"
            fab
            elevation="2"
            class="blue darken-2"
            :disabled="clapsDisabled"
            @click="playAudio('clap')">
              <v-icon size="60px">mdi-hand-back-right</v-icon>
              <v-icon v-if="!clapsDisabled" size="60px" class="clap-hand-b" style="position:absolute;color:rgb(200,200,200);">mdi-hand-back-right</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="3" class="d-flex justify-space-around">
          <v-btn height="80px"
            width="80px"
            fab
            class="blue darken-2"
            elevation="2"
            :disabled="bravosDisabled"
            @click="playAudio('bravo')">
              <v-icon size="60px">mdi-bullhorn</v-icon>
          </v-btn>
        </v-col>

        <v-col cols="3" class="d-flex justify-space-around">
          <v-btn height="80px"
            width="80px"
            fab
            elevation="2"
            class="blue darken-2"
            :disabled="writeDisabled"
            @click="writeCommentary">
              <v-icon size="60px">mdi-file-document-edit-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-toolbar>
  </div>
</template>

<script>
  // @ is an alias to /src
  const { rest } = require('../misc/rest')
  import { mapState } from 'vuex'
  const moment = require('moment-timezone')
  import { Stack, StackItem } from 'vue-stack-grid'
  import Waterfall from 'vue-waterfall/lib/waterfall'
  import WaterfallSlot from 'vue-waterfall/lib/waterfall-slot'

  export default {
    name: 'Applause',

    components: {
      Stack,
      StackItem,
      Waterfall,
      WaterfallSlot
    },

    data: () => ({
      scrolled: 0,
      eventId: null,
      eventTitle: '',
      pseudonym: '',
      seeds: [],
      particles: [],
      batches: [],
      fwkPtcIniV: 0.5,
      fwkSedIniV: 0.5,
      fwkPtcIniT: 2500,
      fwkSedIniT: 1000,
      a: 0.0005,
      g: 0.0005,
      v: 0.3,
      cursorXOffset: 5,
      cursorYOffset: 0,
      before: Date.now(),
      id: null,
      brd: null,
      rocketDisabled: false,
      clapsDisabled: false,
      bravosDisabled: false,
      writeDisabled: false,
      audioClaps: ['applause1'],
      audioBravos: ['bravo1'],
      refresher: null,
      noteRefresher: null,
      actions: [],
      dialog: true,
      yourThoughts: '',
      writeSomething: false,
      notes: [],
      lastNoteId: null,
      registeredFonts: [
        'Parisienne',
        'Sacramento',
        'Gloria Hallelujah',
        'Satisfy',
        'Dancing Script',
        'Indie Flower',
        'Shadows Into Light Two',
      ],
      registeredColors: [
        'blue',
        'indigo',
        'teal',
        'orange',
        'blue-grey',
        'black'
      ],
      activeActions: {},
    }),

    computed: {
        ...mapState({ user: 'user'})
    },

    methods: {
      formatDate: function(date) {
        return moment(date).format('HH:mm:ss')
      },

      getColor: function() {
        return this.registeredColors[Math.round(Math.random() * (this.registeredColors.length-1))]
      },

      setSpacer: function() {
        return Math.random() > 0.8
      },

      getFont: function() {
        return this.registeredFonts[Math.round(Math.random() * (this.registeredFonts.length-1))]
      },

      getFontSize: function() {
        return `${Math.round(Math.random() * 10) + 30}px`
      },

      writeCommentary: function() {
        this.writeSomething = true
        this.dialog = true
      },

      publishCommentary: function() {
        const data = {
          user: this.user.id,
          author: this.pseudonym,
          type: 'text',
          text: this.yourThoughts,
          style: {
            fontColor: this.getColor(),
            fontSize: this.getFontSize(),
            fontFamily: this.getFont(),
            rotation: `${(Math.random() < 0.5 ? -1 : 1) * Math.random() * 10}deg`
          }
        }

        rest.request(`/action/${this.eventId}`, 'post', data)
            .then(result => {
              if (result.success) {
                this.dialog = false
                this.writeSomething = false
                this.yourThoughts = ''

                this.notes.push(result.data)
              }
            })
      },

      playAudio: function(source, id, activeId) {
        const newAudio = new Audio()
        newAudio.type = 'audio/wav'

        if (!id) {
          if (source === 'clap') {
            id = this.audioClaps[Math.round(Math.random() * (this.audioClaps.length-1))]
            this.clapsDisabled = true
            newAudio.onended = () => {
              this.clapsDisabled = false;
              this.audioEnded(id)
            }
          } else {
            id = this.audioBravos[Math.round(Math.random() * (this.audioBravos.length-1))]
            this.bravosDisabled = true
            newAudio.onended = () => {
              this.bravosDisabled = false;
              this.audioEnded(id)
            }
          }

          rest.request(`/action/${this.eventId}`, 'post', {user: this.user.id, type: 'audio', id})
            .then(result => {
              if (result.success) {
                newAudio.src = `/assets/${id}.mp3`
                newAudio.play()
              }
            })
        } else {
          newAudio.src = `/assets/${id}.mp3`
          newAudio.play()
          newAudio.onended = () => {this.activeActions[activeId] = false}
        }
        //this.$refs[refAudio].play()
      },

      audioEnded: function(id) {
        if (id) {
          rest.request(`/action/${this.eventId}`, 'put', {user: this.user.id, type: 'audio', id})
        }
      },

      newFireworkParticle: function(x, y, angle) {
        var fwkPtc = document.createElement("DIV");
        fwkPtc.setAttribute('class', 'fireWorkParticle');
        fwkPtc.time = this.fwkPtcIniT;
        while(angle > 360)
          angle -= 360;
        while(angle < 0)
          angle += 360;
        fwkPtc.velocity = [];
        if(angle > 270)
        {
          fwkPtc.velocity.x = this.fwkPtcIniV * Math.sin(angle * Math.PI / 180) * (1 - Math.random() * this.v);
          fwkPtc.velocity.y = this.fwkPtcIniV * Math.cos(angle * Math.PI / 180) * (1 - Math.random() * this.v);
        }
        else if(angle > 180)
        {
          fwkPtc.velocity.x = this.fwkPtcIniV * Math.sin(angle * Math.PI / 180) * (1 - Math.random() * this.v);
          fwkPtc.velocity.y = this.fwkPtcIniV * Math.cos(angle * Math.PI / 180) * (1 - Math.random() * this.v);
        }
        else if(angle > 90)
        {
          fwkPtc.velocity.x = this.fwkPtcIniV * Math.sin(angle * Math.PI / 180) * (1 - Math.random() * this.v);
          fwkPtc.velocity.y = this.fwkPtcIniV * Math.cos(angle * Math.PI / 180) * (1 - Math.random() * this.v);
        }
        else
        {
          fwkPtc.velocity.x = this.fwkPtcIniV * Math.sin(angle * Math.PI / 180) * (1 - Math.random() * this.v);
          fwkPtc.velocity.y = this.fwkPtcIniV * Math.cos(angle * Math.PI / 180) * (1 - Math.random() * this.v);
        }
        fwkPtc.position = [];
        fwkPtc.position.x = x;
        fwkPtc.position.y = y;
        fwkPtc.style.left = fwkPtc.position.x + 'px';
        fwkPtc.style.top = fwkPtc.position.y + 'px';
        if(this.particles == null)
          this.particles = [];
        this.particles.push(fwkPtc);
        return fwkPtc;
      },

      newFireWorkOnClick: function() {
        const event = {
          pageX: Math.random() * this.$refs.board.clientWidth,
          pageY: Math.random() * this.$refs.board.clientHeight
        }
        this.rocketDisabled = true

        const startPos = {
          x: event.pageX - this.brd.offsetLeft + this.cursorXOffset,
          y: event.pageY - this.brd.offsetTop + this.cursorYOffset
        }

        rest.request(`/action/${this.eventId}`, 'post', {user: this.user.id, type: 'rocket', pos: startPos})

        this.newFireworkSeed(startPos.x, startPos.y);
      },

      newFireworkSeed: function(x, y) {
        var fwkSed = document.createElement("DIV");
        fwkSed.setAttribute('class', 'fireWorkSeed');
        this.brd.appendChild(fwkSed);
        fwkSed.time = this.fwkSedIniT;
        fwkSed.velocity = [];
        fwkSed.velocity.x = 0;
        fwkSed.velocity.y = this.fwkSedIniV;
        fwkSed.position = [];
        fwkSed.position.x = x;
        fwkSed.position.y = y;
        fwkSed.style.left = fwkSed.position.x + 'px';
        fwkSed.style.top = fwkSed.position.y + 'px';
        if(this.seeds == null)
          this.seeds = [];
        this.seeds.push(fwkSed);
        return fwkSed;
      },
      
      newFireWorkStar: function(x, y) {
        var fwkBch = document.createElement("DIV");
        fwkBch.setAttribute('class', 'fireWorkBatch');
        var a = 0;
        while(a < 360)
        {
          var fwkPtc = this.newFireworkParticle(x, y, a);
          fwkBch.appendChild(fwkPtc);
          a += 5;
        }
        this.brd.appendChild(fwkBch);
      },

      frame: function() {
        var current = Date.now();
        var deltaTime = current - this.before;
        this.before = current;

        for(let i in this.seeds) {
          var fwkSed = this.seeds[i];
          fwkSed.time -= deltaTime;

          if(fwkSed.time > 0)
          {
            fwkSed.velocity.x -= fwkSed.velocity.x * this.a * deltaTime;
            fwkSed.velocity.y -= this.g * deltaTime + fwkSed.velocity.y * this.a * deltaTime;
            fwkSed.position.x += fwkSed.velocity.x * deltaTime;
            fwkSed.position.y -= fwkSed.velocity.y * deltaTime;
            fwkSed.style.left = fwkSed.position.x + 'px';
            fwkSed.style.top = fwkSed.position.y + 'px';
          }
          else
          {
            this.newFireWorkStar(fwkSed.position.x, fwkSed.position.y);
            fwkSed.parentNode.removeChild(fwkSed);
            this.seeds.splice(i, 1);
          }
        }

        for(let i in this.particles) {
          var fwkPtc = this.particles[i];
          fwkPtc.time -= deltaTime;

          if(fwkPtc.time > 0)
          {
            fwkPtc.velocity.x -= fwkPtc.velocity.x * this.a * deltaTime;
            fwkPtc.velocity.y -= this.g * deltaTime + fwkPtc.velocity.y * this.a * deltaTime;
            fwkPtc.position.x += fwkPtc.velocity.x * deltaTime;
            fwkPtc.position.y -= fwkPtc.velocity.y * deltaTime;
            fwkPtc.style.left = fwkPtc.position.x + 'px';
            fwkPtc.style.top = fwkPtc.position.y + 'px';
          }
          else
          {
            const ptcBatch = fwkPtc.parentNode
            ptcBatch.removeChild(fwkPtc);
            this.particles.splice(i, 1);
            if (!ptcBatch.hasChildNodes()) {
              rest.request(`/action/${this.eventId}`, 'put', {user: this.user.id, type: 'rocket'})
              ptcBatch.parentNode.removeChild(ptcBatch);
              this.rocketDisabled = false
            }
          }
        }
      },

      noteRefresh: function() {
        if (this.$route.name === 'Applause') {
          rest.request(`/note/${this.eventId}/${this.user.id}${this.lastNoteId ? `?lastId=${this.lastNoteId}` : ''}`, 'get')
            .then(result => {
              if (result.success) {
                this.actions = result.data

                let newNotes = this.notes
                for (let action of this.actions) {
                    this.lastNoteId = action._id
                    action.width = Math.floor((Math.random() * 100 ) + 50 + (action.text.length/20*100))
                    action.height = Math.floor((Math.random() * 100 ) + 100 + (action.text.length/20*100))
                    newNotes.push(action)
                }
                this.notes = newNotes.slice(-300)
                if (this.scrolled <= 1) {
                  this.scrolled++
                  this.$refs.boardInner.scrollIntoView(false)
                }
              }
            })
            .finally(() => {
                if (this.noteRefresher) {
                  clearTimeout(this.noteRefresher)
                }
                this.noteRefresher = setTimeout(this.noteRefresh, 1000)
            })
        }
      },

      refresh: function() {
        if ((this.$route.name === 'Applause')) {
          rest.request(`/action/${this.eventId}/${this.user.id}`, 'get')
            .then(result => {
              if (result.success) {
                this.actions = result.data

                for (let action of this.actions) {
                  if (!this.activeActions[action['_id']]) {
                    this.activeActions[action['_id']] = true

                    if (action.type === 'rocket') {
                      const startPos = action.pos
                      this.newFireworkSeed(startPos.x, startPos.y)
                    } else if (action.type === 'audio') {
                      this.playAudio(null, action.id, action['_id'])
                    }
                  }
                }
              }
            })
            .finally(() => {
                if (this.refresher) {
                  clearTimeout(this.refresher)
                }
                this.refresher = setTimeout(this.refresh, 1000)
            })
        }
      },

      agreed: function() {
        this.dialog = false
        this.refresh()
        this.noteRefresh()
      },

    },

    created() {
      this.id = setInterval(this.frame, 5)

      this.eventId = this.$route.params.eventId
      this.eventTitle = this.eventId

      rest.request(`/event/title?id=${this.eventId}`, 'get')
        .then(result => {
          if (result.success) {
            this.eventTitle = result.data.name
          }
        })
    },

    mounted() {
      this.brd = this.$refs.board
      /*navigator.mediaDevices
        .getUserMedia({ audio: true })
        .catch(reason => console.error(`Audio permissions denied: ${reason}`));
        */
    },

    destroyed () {
      clearTimeout(this.noteRefresher)
      clearTimeout(this.refresher)
    },
  }
</script>

<style>
  html, body, #app {
    overflow: hidden;
  }
  .theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
    background-color: #272727 !important;
  }
    .clap-hand-b {
      rotate: 40deg;
      left: 35%;
    }
    #board-inner {
      position: relative;
      overflow: hidden;
      background-image: url('/assets/grid.png');
      background-repeat: repeat;
    }

    @keyframes firework-animation {
			0% {background-color : #ff8426;}
			25% {background-color : #fffc84;}
			50% {background-color : #ff83f4;}
			75% {background-color : #83b6ff;}
			100% {background-color : #ff8426;}
		}
		@keyframes firework-seed-animation	{
			0% {background-color : #ff8426;}
			25% {background-color : #fffc84;}
			100% {background-color : #ff8426;}
		}
		@keyframes firework-fade-animation {
			0% {opacity : 1;}
			50% {opacity : 1;}
			100% {opacity : 0;}
		}
		.fireWorkBatch {
			z-index : 999;
			position: absolute;
			top : 0px;
			left : 0px;
			animation-name : firework-fade-animation;
			animation-timing-function : cubic-bezier(0.5, 0, 1. 1);
			animation-duration : 2.5s;
		}
		.fireWorkParticle {
			z-index : 999;
			position: absolute;
			height : 15px;
			width : 15px;
			border-radius : 7.5px;
			animation-name : firework-animation;
			animation-timing-function : linear;
			animation-duration : 1s;
			animation-iteration-count : infinite;
		}
		.fireWorkSeed {
			z-index : 999;
			position: absolute;
			height : 15px;
			width : 15px;
			border-radius : 7.5px;
			animation-name : firework-seed-animation;
			animation-timing-function : linear;
			animation-duration : 0.5s;
			animation-iteration-count : infinite;
		}	
</style>